export default "__VITE_ASSET__CNlAFA4t__"